<template>
  <div class="actions">
    <ProductPrice :price="price" :instead-of="insteadOf" :from="from"/>
    <v-btn color="primary" @click.stop="$emit('configure')">
      <v-icon v-if="icon" left>{{ icon }}</v-icon>
      {{ label }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import Vue from 'vue';
import ProductPrice from './ProductPrice.vue';

@Component({components: {ProductPrice}})
export default class ProductActions extends Vue {
  @Prop({type: Number, default: 0}) readonly price!: number;
  @Prop({type: Number, default: 0}) readonly insteadOf!: number;
  @Prop({type: Boolean, default: false}) readonly from!: boolean;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly icon!: string;
}
</script>

<style scoped lang="scss">
@use "../stylesheets/Variables.scss" as *;

.actions {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  border-top: 1px solid rgba($shop-black, .12);
  background: $shop-white;
  z-index: 3;

  .v-btn {
    flex: 0 1 auto;
    max-width: 100%;
    min-width: 0;
    height: auto;
    min-height: 36px;
    margin-left: auto;
    padding: 8px 12px;

    ::v-deep .v-btn__content {

      white-space: normal;

      overflow-wrap: anywhere;

    }
    ::v-deep .v-icon--left {
      margin-right: 4px;
    }
  }

  @media (min-width: 960px) {
    gap: 4px;

    .v-btn {
      font-size: 12px;
      letter-spacing: 0;

      ::v-deep .v-btn__content {
        white-space: nowrap;
        overflow-wrap: normal;
      }
    }
  }

  @media (max-width: 959px) {
    padding: 6px 0 2px;
    z-index: 5;

  }
}
</style>
